import { Loader2, TriangleAlert } from "lucide-react";
import type { ReactNode } from "react";
import { ApiError } from "../api";

export function Loading({ label = "Ładowanie…" }: { label?: string }) {
  return (
    <div className="state" role="status" aria-live="polite">
      <Loader2 className="spin icon" size={18} aria-hidden="true" /> {label}
    </div>
  );
}

export function ErrorBox({ error, children }: { error: unknown; children?: ReactNode }) {
  const notFound = error instanceof ApiError && error.status === 404;
  return (
    <div className="state state--error" role="alert">
      <TriangleAlert className="icon" size={18} aria-hidden="true" />
      <strong>{notFound ? "Nie znaleziono." : "Coś poszło nie tak."}</strong>{" "}
      {error instanceof ApiError ? error.message : "Spróbuj ponownie za chwilę."}
      {children}
    </div>
  );
}
